import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Enter = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 24C25.346 24 24 22.654 24 21V11C24 9.346 25.346 8 27 8C28.654 8 30 9.346 30 11V21C30 22.654 28.654 24 27 24ZM27 10C26.449 10 26 10.449 26 11V21C26 21.551 26.449 22 27 22C27.551 22 28 21.551 28 21V11C28 10.449 27.551 10 27 10Z" />
		<path d="M22 16C22 17.053 21.573 18.084 20.828 18.828L14.885 24.771C14.171 25.485 13.226 25.94 12.219 25.994C9.914 26.117 8 24.278 8 22C8 21.297 8.19 20.605 8.538 20H4.75C3.231 20 2 18.769 2 17.25V14.75C2 13.231 3.231 12 4.75 12H8.417C8.069 11.396 7.879 10.703 7.879 10C7.879 7.794 9.673 6 11.879 6C12.932 6 13.963 6.427 14.707 7.171L20.821 13.164C21.573 13.916 22 14.947 22 15.999V16ZM10.005 21.857C9.923 23.024 10.85 24 12 24C12.527 24 13.042 23.787 13.414 23.414L19.414 17.414C19.786 17.042 20 16.526 20 16C20 15.474 19.787 14.958 19.414 14.586L13.3 8.593C12.921 8.214 12.405 8 11.879 8C10.729 8 9.802 8.976 9.884 10.143C9.919 10.638 10.151 11.1 10.502 11.451L11.323 12.272C11.554 12.503 11.677 12.83 11.625 13.153C11.544 13.653 11.119 13.999 10.636 13.999H5C4.448 13.999 4 14.447 4 14.999V16.999C4 17.551 4.448 17.999 5 17.999H10.728C11.055 17.999 11.373 18.143 11.565 18.408C11.862 18.819 11.806 19.365 11.465 19.706L10.624 20.547C10.273 20.898 10.041 21.36 10.006 21.855L10.005 21.857Z" />
	</svg>
);

export default Enter;
